enum Status {
  default = 'default',
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  info = 'info',
  danger = 'danger',
  warning = 'warning',
  blue = 'blue',
  // muted = 'muted',
  // disabled = 'disabled',
  button = 'button',
  light = 'light',
  icon = 'white',
  border = 'border'
}

export default Status;
